<template>
<div>
	<ul class="title-nav">
		<li v-on:click="routeBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="fas fa-pen-nib fa-fw"></i> PROFESSIONAL SERVICES</div>
		</li>
	</ul>
	<div class="mb-5 mt-4">
		<h3 class="mb-2 text-center">
			GET STUFF DONE
		</h3>
		<p>
			Scoutred has a large network of service providers in the development industry. Let’s get you connected with professionals that can move your project forward. What are you looking to get done?
		</p>
		
	</div>
	
	<ul class="sub-nav">
		<li v-if="categories" v-for="(category, index) in categories" v-on:click="routeService(category)">
			<span class="text-uppercase sub-nav-title">{{category.name}}</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
	</ul>

	<div class="mb-3">
		<div class="text-right">
			<small><a class="text-muted" href="">Are you a service provider?</a></small>
		</div>
	</div>

</div>
</template>

<style>

.button-label{line-height:31px;}
.font-sm{font-size:0.8em;}
</style>

<script>

//const categories = ['entitlement','feasibility','financing','geotechnical','permitting','planning','structural engineering','surveying','utility','other']

export default {
	name:'parcel-services',
	data:()=>{
		return {
		}
	},
	props: {
		parcel:{
			type:Object
		},
		addressId:{}
	},
	computed: {
		categories: function() {
			//console.log('parcel computed:',this.$store.state.parcel.rec);
			return this.$store.state.service.categories;
		},
	},
	created: function(){
		this.getCategories();
	},
	methods:{
		getCategories: function(){
			this.loadError = null;
			this.$store.dispatch('SERVICE_CATEGORIES_GET', {}).catch((error)=>{
				this.loadError = error;
			});			
		},
		routeService:function(category){
			this.$router.push({
				name:'parcel-service',
				params:{
					id:this.parcel.id,
					categoryId:category.id,
				},
				query:{
					addressId:this.addressId
				}
			});
		},
		routeBack:function(){
			this.$router.push({
				name:'parcels',
				params:{
					id:this.parcel.id
				},
				query:{
					addressId:this.addressId
				}
			});
		}
	}
}

</script>




// WEBPACK FOOTER //
// src/components/parcel/parcel-services.vue